import React from 'react';
import DistributionChart from './DistributionChart';

/** Engagement & participation split — source: mockup L476–557. */
const EngagementSplit = (): React.JSX.Element => (
  <section className="oq-engagement">
    <div className="oq-container oq-engagement__inner">
      <div className="oq-engagement__row">
        <div className="oq-engagement__copy">
          <div className="oq-engagement__kicker oq-bebas">ENGAGEMENT &amp; PARTICIPATION</div>
          <h2 className="oq-engagement__title oq-bebas">
            See exactly how active your members are
          </h2>
          <p className="oq-engagement__subtitle">
            Every session booking feeds a live picture of participation. See where your
            membership is heading, predict next season&apos;s numbers, and plan your club
            accordingly.
          </p>
          <DistributionChart />
        </div>

        <div className="oq-engagement__phone" aria-hidden="true">
          {/* Real app screenshot, used exactly as supplied — it carries its own
              device frame on a transparent background, so no PhoneFrame here. */}
          <img
            src="/images/engagement-profile.png"
            alt=""
            className="oq-engagement__shot"
            loading="lazy"
            width="1080"
            height="1920"
          />
        </div>
      </div>
    </div>
  </section>
);

export default EngagementSplit;
